import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { MeUser } from './models/me-user';

export interface FeatureFlagConfig {
  [string: string]: boolean | undefined | null;
}

@Injectable({
  providedIn: 'root'
})

export class FeatureFlagService {
  
  constructor(private http: HttpClient) {
    this.updateFlagConfiguration();
  }
  
  featureFlagUrl = './assets/SXIAssets/featureFlag.json';
  flagConfig: BehaviorSubject<FeatureFlagConfig | null> = new BehaviorSubject<FeatureFlagConfig | null>(null);
  flagConfig$: Observable<FeatureFlagConfig | null> = this.flagConfig.asObservable();


  getFeatureFlags(): Observable<FeatureFlagConfig> {
    return this.http.get<FeatureFlagConfig>(this.featureFlagUrl)
  }

  updateFlagConfiguration() {
    this.getFeatureFlags().subscribe((flags) => {
      this.flagConfig.next(flags);
      sessionStorage.setItem('featureFlags', JSON.stringify(flags));
    })
  }

  hasFeatureFlag(flag: string): Observable<boolean> {
    return this.flagConfig$.pipe(
      map((flags) => {
        return flags?.[flag] ?? false;
      })
    );
  }
}
